var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.49963,
    y: 2.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#0067E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6352 8.65443C14.917 8.65443 15.1475 8.42388 15.1475 8.1421C15.1475 7.86032 14.917 7.62978 14.6352 7.62978L9.56318 7.57001H9.55464C9.27286 7.57001 9.04232 7.80055 9.04232 8.08233C9.04232 8.36411 9.27286 8.59465 9.55464 8.59465L11.0062 8.61173C11.732 8.62027 12.3639 9.0899 12.5774 9.78151L9.53754 9.74735H9.52901C9.24723 9.74735 9.01668 9.97789 9.01668 10.2597C9.01668 10.5415 9.24723 10.772 9.52901 10.772L12.5688 10.8062C12.3383 11.4893 11.6979 11.9503 10.9721 11.9418L9.5205 11.9247C9.23872 11.9247 9.00817 12.1467 8.99963 12.4285C8.99963 12.5737 9.05086 12.7018 9.15333 12.8042L12.7481 16.2709C12.9445 16.4673 13.269 16.4673 13.4739 16.2709C13.6789 16.0745 13.6703 15.7501 13.4739 15.5451L13.4654 15.5366L10.8013 12.9579H10.9892C12.27 12.9579 13.3715 12.0614 13.6276 10.8062L14.6096 10.8147H14.6181C14.8999 10.8147 15.1304 10.5842 15.1304 10.3024C15.1304 10.0206 14.8999 9.79009 14.6181 9.79009L13.6362 9.78155C13.5593 9.36315 13.38 8.96183 13.1153 8.62028L14.6352 8.65443Z",
    fill: "#0067E2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/Payments.c266dd3b48a460ece2d95698caadae79.svg";
export { ForwardRef as ReactComponent };